var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu8Active(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1507_44684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8413 7.14038C20.6487 7.14038 20.4512 7.19478 20.2648 7.31418L17.4753 9.10128L16.8831 9.48068V14.5194L17.4753 14.8988L20.2648 16.6857C20.4512 16.8051 20.6489 16.8597 20.8415 16.8597C21.4456 16.8597 21.9998 16.3236 21.9998 15.5743V8.42588C21.9998 7.67678 21.4454 7.14038 20.8413 7.14038Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3257 10.1951C16.2976 8.73996 16.3069 6.89826 15.1814 5.77466C14.0931 4.68816 12.5079 4.53166 11.0163 4.49476C10.3315 4.47636 9.74734 4.46716 9.16304 4.46716C8.57874 4.46716 7.99454 4.47636 7.30974 4.49476C5.82754 4.53166 4.23284 4.68816 3.14474 5.77466C2.01904 6.90746 2.02844 8.74916 2.00024 10.2043V13.805C2.02844 15.2601 2.01904 17.1018 3.14474 18.2253C4.23284 19.3118 5.81824 19.4685 7.30974 19.5052C7.99454 19.5236 8.57874 19.5329 9.16304 19.5329C9.74734 19.5329 10.3315 19.5236 11.0163 19.5052C12.4984 19.4685 14.0931 19.3118 15.1814 18.2253C16.3069 17.1018 16.2977 15.2601 16.3257 13.805C16.3352 13.2064 16.3445 12.5986 16.3352 12.0001C16.3352 11.4016 16.3352 10.8029 16.3257 10.1951Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4571 12.6171L10.0258 13.4435L8.59454 14.2699C8.11944 14.5442 7.52563 14.2014 7.52563 13.6528V10.3473C7.52563 9.79881 8.11944 9.45591 8.59454 9.73021L10.0258 10.5566L11.4571 11.383C11.9321 11.6573 11.9321 12.3428 11.4571 12.6171Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1507_44684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu8Active);
export default __webpack_public_path__ + "static/media/menu8active.a6f07bcebab60d7e4004b42246bc1c77.svg";
export { ForwardRef as ReactComponent };